import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { ReactNode } from "react";
import { jwtDecode } from "jwt-decode";

type DecodedToken = {
  id: string;
  email: string;
  role: "ADMIN" | "CLIENT" | "FACILITATOR";
  exp: number;
  iat: number;
};

type FacilitatorProtectedRouteProps = {
  children: ReactNode;
};

export function FacilitatorProtectedRoute({ children }: FacilitatorProtectedRouteProps) {
  const location = useLocation();
  const token = Cookies.get("token");

  if (!token) {
    return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      Cookies.remove("token");
      return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
    }

    if (decoded.role === "ADMIN") {
      return <Navigate to="/admin/companies" replace />;
    }

    if (decoded.role === "CLIENT") {
      return <Navigate to="/dashboard" replace />;
    }

    if (decoded.role !== "FACILITATOR") {
      Cookies.remove("token");
      return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
  } catch {
    Cookies.remove("token");
    return <Navigate to="/facilitator/login" state={{ from: location }} replace />;
  }
}
